var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLineLasg(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1822,
    height: 1822,
    viewBox: "0 0 1822 1822",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1777.37 0C1777.37 0 666.513 266.605 666.513 666.513C666.513 1066.42 1244.16 1021.99 1244.16 1199.72C1244.16 1377.46 177.737 1644.07 0 1688.5L44.4342 1821.8C44.4342 1821.8 1377.46 1555.2 1377.46 1199.72C1377.46 844.25 799.816 977.553 799.816 666.513C799.816 355.474 1821.8 133.303 1821.8 133.303L1777.37 0Z",
    fill: "#009C3E"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLineLasg);
export default __webpack_public_path__ + "static/media/line__lasg.760981dd55f45d16db27a6767ce99517.svg";
export { ForwardRef as ReactComponent };